<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="row">
            <div class="col-12">
                <div class="page_action">
                    <div class="tw-w-full text-right">
                        <button
                            type="button"
                            class="btn btn-sm btn-dark"
                            data-toggle="modal"
                            data-target="#selectForm"
                        >
                            <i class="fa fa-file-text-o"> เลือกฟอร์ม</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="" v-if="formSalePageData">
            <div class="">
                <div>
                    <label class="m-0"> ชื่อฟอร์ม: </label>
                    <p>{{ formSalePageData.title }}</p>
                </div>
                <div>
                    <label class="m-0"> ข้อความแจ้งผู้กรอกฟอร์ม: </label>
                    <p>{{ formSalePageData.message_text }}</p>
                </div>
            </div>
            <div>
                <label> ตัวอย่างฟอร์ม</label>
                <div class="card shadow card__p pt-0">
                    <form-component
                        :title="formSalePageData.title"
                        :description="formSalePageData.description"
                        :formBodies="formSalePageData.bodies"
                        :shop="shop"
                        :salepage_id="salepageId"
                    ></form-component>
                </div>
            </div>
        </div>
        <div v-else class="no-data__form">
            <a
                :href="
                    `/backend/s/${shop}/forms/create?redirectUrl=/backend/s/${shop}/salepages/${salepageId}`
                "
                class=""
            >
                ไม่พบข้อมูล สร้างฟอร์มใหม่
            </a>
        </div>
        <div class="modal" id="selectForm" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="tw-font-bold">
                            เลือกฟอร์ม
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table table-hover mb-0 c_list">
                                <thead>
                                    <tr>
                                        <th class="tw-w-4/12">ชื่อฟอร์ม</th>
                                        <th class="tw-w-3/12">กล่องข้อความ</th>
                                        <th class="tw-w-3/12">ข้อความตอบรับ</th>
                                        <th class="text-right">ACTION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in formData"
                                        :key="index"
                                    >
                                        <td>
                                            {{ item.title }}
                                        </td>
                                        <td>
                                            <div id="form-section">
                                                <span
                                                    class="tag-style"
                                                    v-for="(itemInput,
                                                    indputIndex) in item.bodies"
                                                    :key="
                                                        `input-${indputIndex}`
                                                    "
                                                >
                                                    {{ itemInput.input }}
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            {{ item.message_text }}
                                        </td>
                                        <td class="text-right">
                                            <button
                                                type="button"
                                                :class="
                                                    `btn btn-sm ${
                                                        formSalePageData &&
                                                        formSalePageData.id ==
                                                            item.id
                                                            ? 'btn-secondary'
                                                            : 'btn-primary'
                                                    }`
                                                "
                                                :disabled="
                                                    formSalePageData &&
                                                        formSalePageData.id ==
                                                            item.id
                                                "
                                                @click="setFormSalePage(item)"
                                            >
                                                เลือกฟอร์ม
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center" colspan="4">
                                            <a
                                                :href="
                                                    `/backend/s/${shop}/forms/create?redirectUrl=/backend/s/${shop}/salepages/${salepageId}`
                                                "
                                            >
                                                ไม่พบข้อมูลฟอร์ม
                                                กรุณาสร้างฟอร์มใหม่
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
    props: {
        shop: {
            required: true,
            type: String
        },
        salepageId: {
            required: true,
            type: Number
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            loading: false,
            status: {
                addProduct: false
            },
            formSalePageData: {},
            formData: []
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async setFormSalePage(item) {
            await axios
                .post(
                    `/backend/s/${this.shop}/forms/manage-salepage/${this.salepageId}`,
                    item
                )
                .then(res => {
                    this.formSalePageData = res.data.formSalePage;
                    this.form = {};
                });
        },
        async getData() {
            await axios
                .get(
                    `/backend/s/${this.shop}/forms/manage-salepage/${this.salepageId}`
                )
                .then(res => {
                    // this.formSalePageData = res.data.formSalePage;
                    this.formData = res.data.form;
                    this.form = {};
                    this.formSalePageData = res.data.formSalePage;
                });
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.no-data__form {
    border: 2px solid #fed736;
    border-radius: 4 px;
    padding: 20px;
    text-align: center;
    margin: 20px;
    font-size: 18px;
    font-weight: bold;
}
#form-section {
    width: 300px;
    display: flex;
    flex-wrap: wrap;
    .tag-style {
        margin: 2px;
        background: #fde273;
        color: #000;
        padding: 4px 8px;
        border-radius: 5px;
    }
}
.card-header-forms {
    background-color: var(--primary-color3) !important;
}

.card-body-forms {
    border: 1px dashed var(--primary-color3) !important;
}
label {
    color: #000;
}
.card__p {
    padding: 20px;
}
@media (max-width: 640px) {
    .card__p {
        padding: 10px;
    }
}
</style>
